// extracted by mini-css-extract-plugin
var _1 = "yl9gKDv5anLBb7L6PhaU";
var _2 = "DBaD7_hFJbyA1GLrDUBD";
var _3 = "#000000";
var _4 = "#76F366";
var _5 = "#EB8632";
var _6 = "#ECC834";
var _7 = "#21FC87";
var _8 = "#EA4A30";
var _9 = "#C7EA45";
var _a = "#272B2B";
var _b = "#BDBDBD";
var _c = "#7D7D7D";
var _d = "#6A0DAD";
var _e = "#3A65FF";
var _f = "#4A90E2";
var _10 = "#ffffff";
var _11 = "pWfc0ZguLwrxVtNksI0Z";
var _12 = "Xnegsj7jYVEoJsZedcNZ";
var _13 = "1200px";
var _14 = "992px";
var _15 = "1366px";
var _16 = "768px";
var _17 = "1475px";
var _18 = "576px";
var _19 = "1600px";
var _1a = "320px";
var _1b = "2500px";
var _1c = "p3uiRSYDRL3E75FBnV7i";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "colorBlack", _4 as "colorGradeEX", _5 as "colorGradeFR", _6 as "colorGradeGD", _7 as "colorGradeOU", _8 as "colorGradePR", _9 as "colorGradeVG", _a as "colorNeutral", _b as "colorNeutralLighest", _c as "colorNeutralLight", _d as "colorNonOwnerSweetLine", _e as "colorOwnerSweetLine", _f as "colorRegularLinks", _10 as "colorWhite", _11 as "content", _12 as "reset-button", _13 as "screenlg", _14 as "screenmd", _15 as "screenml", _16 as "screensm", _17 as "screenxlg", _18 as "screenxs", _19 as "screenxxlg", _1a as "screenxxs", _1b as "screenxxxlg", _1c as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "colorBlack": _3, "colorGradeEX": _4, "colorGradeFR": _5, "colorGradeGD": _6, "colorGradeOU": _7, "colorGradePR": _8, "colorGradeVG": _9, "colorNeutral": _a, "colorNeutralLighest": _b, "colorNeutralLight": _c, "colorNonOwnerSweetLine": _d, "colorOwnerSweetLine": _e, "colorRegularLinks": _f, "colorWhite": _10, "content": _11, "reset-button": _12, "screenlg": _13, "screenmd": _14, "screenml": _15, "screensm": _16, "screenxlg": _17, "screenxs": _18, "screenxxlg": _19, "screenxxs": _1a, "screenxxxlg": _1b, "single-page-responsive-font-size": _1c }
